import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * The old standalone AI page (/workflows/ai) is retired: Build with AI lives in the
 * workflow editor. Old links land in the editor with the panel open, editing the
 * workflow ?modify= named.
 */
export function LegacyAIRedirect() {
  const { orgId } = useParams<{ orgId: string }>();
  const [searchParams] = useSearchParams();
  const target = searchParams.get('modify');
  const path = target ? `/dashboard/${orgId}/workflows/${target}/edit-v4?ai=1` : `/dashboard/${orgId}/create-workflow-v4?ai=1`;
  return <Navigate to={path} replace />;
}
